module.exports = __webpack_public_path__ + "static/img/气象站.1c8d4f61.png";